const containerPDPBuyBox = document.querySelector('.js-pdp-buy-box')

if(containerPDPBuyBox){
  const blocks = containerPDPBuyBox.querySelectorAll('.js-pdp-buy-box-block');

  const cleanBlocks = () => {
    blocks.forEach(el => el.classList.remove('active'));
  }
  
  /* Custom */
  const subscription = containerPDPBuyBox.querySelector('.js-pdp-buy-box-subscription');
  const oneTime = containerPDPBuyBox.querySelector('.js-pdp-buy-box-one-time');

  /* Price */
  const priceWrapper = document.querySelector('.js-main-pdp-price');
  const priceOld = containerPDPBuyBox.querySelector('.js-pdp-buy-box-price')?.value;
  const priceNew = containerPDPBuyBox.querySelector('.js-pdp-buy-box-price-new')?.value;

  /* Subscription */
  subscription.addEventListener('click', ()=>{
    cleanBlocks();
    subscription.parentElement.classList.add('active');
    const subscription_rc = document.querySelector('[data-option-subsave]');
    subscription_rc.click();
    if(priceWrapper && priceNew){
      priceWrapper.innerText = priceNew;
    }
  });

  /* One time */
  oneTime.addEventListener('click', ()=>{
    cleanBlocks();
    oneTime.parentElement.classList.add('active');
    const oneTime_rc = document.querySelector('[data-option-onetime]');
    oneTime_rc.click();
    if(priceWrapper && priceOld){
      priceWrapper.innerText = priceOld;
    }
  });

  /* Select */

  const select = containerPDPBuyBox.querySelector('.js-pdp-buy-box-select');

  select.addEventListener('change', e => {
    const selectedId = e.target.selectedOptions[0].id;
    
    const select_rc = document.querySelector('[data-plans-dropdown]');

    select_rc.selectedIndex = selectedId;
    select_rc.dispatchEvent(new Event("change"));
  })
}